import React, { FC } from 'react';
import { componentService } from '@core/js/services/component.service';
import { WebContent } from '@core/js/components/system/WebContent';

type WCProps = {
    id: string
}

/* TODO CODERE (NOTES):
    We still need replacers/codere-theme/wc, as some backbone templates uses it,
    and react replacers can't be used in backbone.
    This component supposed to replace backbone replacer, but anyway seems like main/WebContent do the same.
    Might be deleted in future (CMS WebContents to review, to map it to WebContent replacer instead of WC)
*/
export const WC: FC<WCProps> = ({ id }) => {
    return (
        <WebContent className="wc-replacer" id={id}/>
    );
};

componentService.registerWebContentComponents({ WC });
